import axios from 'axios';
import { getCurrentApiHost, API_NAMESPACE, API_VERSION } from 'config/environment';
// Single-flight guard: triggerOtp is invoked independently from more than one
// caller (link-action.tsx, hooks/use-login-with-token.ts) with no shared
// knowledge of whether a request for the same token is already in flight. A
// duplicate call for a token that's already being requested (extra render,
// racing mounts) reuses the pending request instead of firing a second POST —
// the backend mints a brand-new OTP per call and overwrites the unconsumed
// one, so an extra request silently invalidates the code already emailed.
// Cleared once the request settles so a later legitimate resend still fires.
const inFlightTriggerOtpRequests = new Map();
export const triggerOtp = (token)=>{
    const inFlightRequest = inFlightTriggerOtpRequests.get(token);
    if (inFlightRequest) {
        return inFlightRequest;
    }
    const url = `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/users/trigger-otp?token=${token}`;
    const request = axios.post(url).finally(()=>{
        inFlightTriggerOtpRequests.delete(token);
    });
    inFlightTriggerOtpRequests.set(token, request);
    return request;
};
export const validateOtp = async (token, otpInput)=>{
    const url = `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/users/validate-otp?token=${token}`;
    const response = await axios.post(url, {
        otp: otpInput
    });
    return response.data;
};
